import React, { useCallback } from "react";
import DynamicLinesDialog from "../../../components/DynamicLinesDialog";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { accountsmanagement } from "../../../config";
import { allAccountSubCategories } from "../../../data/Axios/queries";

const base_url = accountsmanagement.uri;

const ClientReceiptDetailDialog = ({ open, onClose, receiptData, refetchData }) => {

    const loadAccountSubCategories = useCallback(async () => {
        const data = await graphqlQuery(allAccountSubCategories, base_url);
        return (data || []).filter((subCat) => [34, 37].includes(subCat.id));
    }, []);

    const formFields = [
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true,
        },
        {
            name: "accountSubCategoryId",
            label: "Account Subcategory",
            type: "select",
            required: true,
        },
        {
            name: "amount",
            label: "Amount",
            type: "number",
            required: true,
        },
    ];

    const columns = [
        { field: "id", headerName: "ID", flex: 0.5 },
        { field: "description", headerName: "Description", flex: 2 },
        {
            field: "accountSubCategoryName",
            headerName: "Account Subcategory",
            flex: 1.5,
        },
        {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            format: "currency",
        },
    ];


    const queryConfig = {
        name: "receiptLines",
        modelName: "receiptLines",
        inputField: "receiptId",
        fields: [
            "id",
            "description",
            "accountSubCategoryId",
            "accountSubCategoryName",
            "amount",
            "isActive",
        ],
    };

    const mutationConfig = {
        create: "createReceiptLine",
        update: "updateReceiptLine",
        modelName: "newReceiptLine",
        updateModelName: "updateReceiptLines",
    };

    return (
        <DynamicLinesDialog
            open={open}
            onClose={onClose}
            title={`Receipt Lines – ${receiptData?.referenceNumber || ""}`}
            parentData={receiptData}
            parentIdField="receiptId"
            baseUrl={base_url}
            queryConfig={queryConfig}
            mutationConfig={mutationConfig}
            refetchData={refetchData}
            formFields={formFields}
            columns={columns}
            optionsLoaders={{
                accountSubCategoryId: loadAccountSubCategories,
            }}
            additionalMutationData={{ isActive: 1 }}
            readOnlyInfo={{
                fields: [
                    {
                        label: "Receipt",
                        getValue: () =>
                            receiptData?.referenceNumber || "N/A",
                    },
                ],
            }}
            canAdd={true}
        />
    );
};

export default ClientReceiptDetailDialog;
